<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Sound and Affect</h1>
<h1 class="bk1">Voice, Music, World</h1>
<p class="bkau">Edited by Judith Lochhead, Eduardo Mendieta, and Stephen Decatur Smith</p>
<p class="bkpub">University of Chicago Press    Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lochhead-0003.vue?6855681a